import React from 'react';
import KPISet from '../components/KPISet';
import List from './List';
import { Box } from '@mui/joy';
import JSONPretty from 'react-json-pretty';
import { useDrawer } from 'src/mtska-frontend-app-component';

const dataProviderName = 'advertisings/advertisingcost';

const Default = () => {
    const { activate } = useDrawer();

    const now = new Date();
    const startOfYear = new Date(`${now.getFullYear()}-01-01`);
    const endOfYear = new Date(`${now.getFullYear()}-12-31`);
    const defaultFilters = {
        items: [
            {
                field: "registered_at",
                value: { from: startOfYear.toISOString().split('T')[0], to: now.toISOString().split('T')[0] },
                operator: "between"
            }
        ]
    };

    return <>
        <KPISet dataProviderName={dataProviderName} filters={defaultFilters} />
        <List filters={defaultFilters} />
    </>

}

export default Default;


